import { useState, useEffect } from 'react'
import { ThemeProvider, CssBaseline, Grid } from '@material-ui/core'
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Definitation from './components/Definition';
import Home from './components/Home';
import Bookmarks from './components/Bookmarks';
import theme from './theme/theme'


const App = () => {
  const [bookmarks, setBookmarks] = useState(JSON.parse(localStorage.getItem('bookmarks')) || {});

  useEffect(() => {
    localStorage.setItem('bookmarks', JSON.stringify(bookmarks))
  }, [bookmarks])

  const addToBookmarks = (word, meanings) => {
    setBookmarks(old => ({ ...old, [word]: meanings }))
  };

  const removeFromBookmarks = word => {
    setBookmarks(old => {
      const tmp = { ...old };
      delete tmp[word];
      return tmp;
    })
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Grid sx={{ p: 2, mt: { xs: 0, sm: 2 } }} container justifyContent="center">
        <Grid item xs={12} sm={8} md={5} lg={3}>
          <Router>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/bookmarks">
              <Bookmarks bookmarks={bookmarks} />
            </Route>
            <Route path="/search/:word">
              <Definitation bookmarks={bookmarks} addToBookmarks={addToBookmarks} removeFromBookmarks={removeFromBookmarks} />
            </Route>
          </Router>
        </Grid></Grid>
    </ThemeProvider>
  )
}

export default App
